import styled from 'styled-components';
import { getLocalId } from 'conversations-internal-schema/file-upload/operators/fileUploadGetters';
import FileUpload from './FileUpload';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "FileUploadsList__Wrapper"
})(["display:flex;overflow:auto;& > *:not(:last-child){margin-right:8px;}"]);
const FileUploadsList = ({
  stagedAttachments,
  onRemoveAttachment,
  className
}) => {
  if (!(stagedAttachments !== null && stagedAttachments !== void 0 && stagedAttachments.size)) return null;
  return /*#__PURE__*/_jsx(Wrapper, {
    className: className,
    children: stagedAttachments.map(attachment => /*#__PURE__*/_jsx(FileUpload, {
      attachment: attachment,
      onRemove: () => onRemoveAttachment(attachment)
    }, getLocalId(attachment)))
  });
};
FileUploadsList.displayName = 'FileUploadsList';
export default FileUploadsList;